export const SPH_ID = "df115826-79b3-4167-82e7-62a5f9fe3134";
export const CYL_ID = "b0ec1e26-6728-4bdc-ae36-ce8f6e99014d";
export const ADD_ID = "64a73d0f-4172-42ba-b536-2d63c9e5fa62";
export const SIDE_ID = "235322f0-3370-46b3-b3d7-543f8f0ea122";

export const SIDE_NAME = "Sisi";
